import show from '@/components/Notify'

export const notify = {
	success(options){
		let message = options
		if(typeof options === 'object') message = options.message
		show(message)
	},
	error(options){
		let message = options
		if(typeof options === 'object') message = options.message
		show(message)
	}
}
